import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { type Genre } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { useCreateGenre } from "../../hooks/genres"
import { initialValuesGenre, validationSchemaGenre } from "./GenreCommon"
import GenreForm from "./GenreForm"

export default function GenreCreate() {
  const createGenre = useCreateGenre()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesGenre(), [])
  const validationSchema = useMemo(() => validationSchemaGenre(), [])

  useBreadcrumbs([{ label: "Generi", href: "/genres/genres" }, { label: "Creazione Genere" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo genere</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createGenre.mutateAsync(values as Genre).then((genre) => {
                navigate(`/genres/genres/${genre.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <GenreForm />
                </Container>
                <BottomFormFixed url="/genres/genres" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
